
// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://gmmfphwrwhvixldazcmp.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImdtbWZwaHdyd2h2aXhsZGF6Y21wIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDY2OTc0NDQsImV4cCI6MjA2MjI3MzQ0NH0.OYfeYW4ehGkrFZ1WW2j21sTPtg_XxaeDgNA722rDqqk";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
  }
});
